// extracted by css-extract-rspack-plugin
export default {"actionsCell":"actionsCell-esNNQa","buttonContainer":"buttonContainer-l7NF56","actionButton":"actionButton-IrMPUs","declineHighlighted":"declineHighlighted-LJNASi"};